module.exports = __webpack_public_path__ + "img/Contacts.13ae13d3.svg";